import { put, call, takeEvery } from 'redux-saga/effects';
import { notification } from 'antd';
import { fetchApiAuth } from '../utils/api';

import {
    getDashboardStatsSuccess,
    getDashboardStatsFailure,
} from './dashboardActions';

const {
    GET_DASHBOARD_STATS_REQUEST,
} = require('./dashboardActions').constants;

function* getDashboardStats() {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: '/dashboard'
        });

        const data = response.data || {};
        yield put(getDashboardStatsSuccess(data));
    } catch (e) {
        notification.error({ message: 'Error detected', description: (e.response ? e.response.data.message : e) });
        yield put(getDashboardStatsFailure(e.response ? e.response.data.message : e));
    }
}

/**
 * Watch actions
 */
export default function* dashboardSaga() {
    yield* [
        takeEvery(GET_DASHBOARD_STATS_REQUEST, getDashboardStats),
    ];
}
